module.exports = __webpack_public_path__ + "img/microsoft.c899823c.svg";